module.exports = __webpack_public_path__ + "img/location.d3a08d4e.svg";